import { AllPages } from './pages/all';
import { router } from './pages/router';

router.resolve(window.location.pathname)
    // TODO: Find whats wrong with this typings, for now its 'any'
    .then(({ params, page }: any) => page.render(params))
    .catch((err) => {
        if (err.message === 'Route not found') return;

        console.error(err);
    })
    .finally(AllPages.render);
